<template>
  <div class="p-4 mb-4 last:mb-0">
    <div class="flex items-top flex-col md:flex-row gap-x-4">
      <div class="w-30 min-w-30 h-40 flex items-center justify-center flex-shrink-0 bg-gray-50 rounded-lg overflow-hidden mb-6 md:mb-0">
        <img
          v-if="showImage"
          :src="getImageSrc(props.editor.image)"
          :alt="props.editor.name"
          class="object-cover w-full h-full"
          @load="onImageLoad"
          @error="onImageError"
        />
        <PersonIcon
          v-else
          class="w-full h-full text-gray-400 bg-faint-grey"
          :data-testid="'person-icon'"/>
      </div>
      <div class="max-w-xl">
        <h4 class="font-roboto text-lg font-bold mb-3">
          {{ props.editor.name }}
        </h4>
        <p class="font-bold mb-5">
          {{ props.editor.area }}
        </p>
        <p class="mb-4">
          {{ props.editor.affiliation }}
        </p>
      </div>
      <div class="md:ml-auto">
        <ButtonComponent
          label="Select"
          variant="secondary"
          :id="'associateEditorSelectButton' + '-' + props.pos"
          data-testid="select-associate-editor-btn"
          @customClick="selectOffice"
          :disabled="isDisabled"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { EditorialOffice } from '@/types'
import ButtonComponent from '../ui-components/ButtonComponent.vue'
import PersonIcon from '@/images/svg/PersonIcon.vue'

const emit = defineEmits(['editorSelected'])

const props = defineProps({
  editor: { required: true, type: Object as () => EditorialOffice },
  pos: { required: false, type: Number, default: 0 },
  selectedEditors: { type: Array as () => EditorialOffice[], required: true },
})

const showImage = ref(true)

function onImageLoad() {
  showImage.value = true
}

function onImageError() {
  showImage.value = false
}

function getImageSrc(image: unknown): string {
  if (!image) return ''
  if (typeof image === 'string') return image
  if (image instanceof URL) return image.href
  return String(image)
}

function selectOffice() {
  emit('editorSelected', props.editor)
}

const isDisabled = computed(() => {
  const alreadySelected = props.selectedEditors.some(
    e => e.peerReviewIdentifier === props.editor.peerReviewIdentifier,
  )
  return props.selectedEditors.length >= 2 && !alreadySelected
})

</script>
